import { useMutation } from "react-query";
import { setTaskPriority, setWorkflowTaskPriority, setProfilingPriority } from "../lib/data";

export const useAssignPriority = (taskType) => {
    return useMutation(({ priority, taskContextKeys, taskTypes, taskKeys }) => {
        if (taskType === "scheduling") {
            return setProfilingPriority(priority, taskKeys);
        }

        if (taskType === "duplicatestaging") {
            return setWorkflowTaskPriority(priority, taskKeys, "DuplicateStagingTask");
        }

        return setTaskPriority(priority, taskContextKeys, taskTypes);
    });
};
